import { IMutationWithoutPayload, IMutation } from '@/store/types/mutation'
import { IState, IMarket, ICategory, IFamily, IRoot, ISector, ISubMarket, ISegment, INomenclature } from './types'
import { GET_MARKETS_INIT,
  GET_MARKETS_SUCCESS,
  GET_MARKETS_ERROR,
  GET_CATEGORIES_INIT,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  GET_FAMILIES_INIT,
  GET_FAMILIES_SUCCESS,
  GET_FAMILIES_ERROR,
  GET_ROOTS_INIT,
  GET_ROOTS_SUCCESS,
  GET_ROOTS_ERROR,
  GET_SECTORS_INIT,
  GET_SECTORS_SUCCESS,
  GET_SECTORS_ERROR,
  GET_SEGMENTS_INIT,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_ERROR,
  GET_SUBMARKETS_INIT,
  GET_SUBMARKETS_SUCCESS,
  GET_SUBMARKETS_ERROR,
  GET_NOMENCLATURES_INIT,
  GET_NOMENCLATURES_SUCCESS,
  GET_NOMENCLATURES_ERROR,
        } from './mutations-types'

const mutationGetNomenclaturesInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetNomenclaturesSuccess: IMutation<IState, INomenclature[]> = (state, nomenclatures) => {
  state.isLoading = false
  state.nomenclatures = nomenclatures
}

const mutationsGetNomenclaturesError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.nomenclatures = []
}

const mutationGetMarketsInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetMarketsSuccess: IMutation<IState, IMarket[]> = (state, markets) => {
  state.isLoading = false
  state.markets = markets
}

const mutationsGetMarketsError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.markets = []
}

const mutationGetCategoriesInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetCategoriesSuccess: IMutation<IState, ICategory[]> = (state, categories) => {
  state.isLoading = false
  state.categories = categories.sort((a: ICategory, b: ICategory) => (a.id > b.id) ? 1 : -1)
}

const mutationsGetCategoriesError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.categories = []
}

const mutationGetFamiliesInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetFamiliesSuccess: IMutation<IState, IFamily[]> = (state, families) => {
  state.isLoading = false
  state.families = families.sort((a: IFamily, b: IFamily) => (a.id > b.id) ? 1 : -1)
}

const mutationsGetFamiliesError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.families = []
}

const mutationGetRootsInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetRootsSuccess: IMutation<IState, IRoot[]> = (state, roots) => {
  state.isLoading = false
  state.roots = roots
}

const mutationsGetRootsError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.roots = []
}

const mutationGetSectorsInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetSectorsSuccess: IMutation<IState, ISector[]> = (state, sectors) => {
  state.isLoading = false
  state.sectors = sectors
}

const mutationsGetSectorsError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.sectors = []
}

const mutationGetSubMarketsInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetSubMarketsSuccess: IMutation<IState, ISubMarket[]> = (state, subMarkets) => {
  state.isLoading = false
  state.subMarkets = subMarkets
}

const mutationsGetSubMarketsError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.subMarkets = []
}

const mutationGetSegmentsInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationGetSegmentsSuccess: IMutation<IState, ISegment[]> = (state, segments) => {
  state.isLoading = false
  state.segments = segments
}

const mutationsGetSegmentsError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.segments = []
}

export default {
  [GET_MARKETS_INIT]: mutationGetMarketsInit,
  [GET_MARKETS_SUCCESS]: mutationGetMarketsSuccess,
  [GET_MARKETS_ERROR]: mutationsGetMarketsError,
  [GET_CATEGORIES_INIT]: mutationGetCategoriesInit,
  [GET_CATEGORIES_SUCCESS]: mutationGetCategoriesSuccess,
  [GET_CATEGORIES_ERROR]: mutationsGetCategoriesError,
  [GET_FAMILIES_INIT]: mutationGetFamiliesInit,
  [GET_FAMILIES_SUCCESS]: mutationGetFamiliesSuccess,
  [GET_FAMILIES_ERROR]: mutationsGetFamiliesError,
  [GET_ROOTS_INIT]: mutationGetRootsInit,
  [GET_ROOTS_SUCCESS]: mutationGetRootsSuccess,
  [GET_ROOTS_ERROR]: mutationsGetRootsError,
  [GET_SECTORS_INIT]: mutationGetSectorsInit,
  [GET_SECTORS_SUCCESS]: mutationGetSectorsSuccess,
  [GET_SECTORS_ERROR]: mutationsGetSectorsError,
  [GET_SUBMARKETS_INIT]: mutationGetSubMarketsInit,
  [GET_SUBMARKETS_SUCCESS]: mutationGetSubMarketsSuccess,
  [GET_SUBMARKETS_ERROR]: mutationsGetSubMarketsError,
  [GET_SEGMENTS_INIT]: mutationGetSegmentsInit,
  [GET_SEGMENTS_SUCCESS]: mutationGetSegmentsSuccess,
  [GET_SEGMENTS_ERROR]: mutationsGetSegmentsError,
  [GET_NOMENCLATURES_INIT]: mutationGetNomenclaturesInit,
  [GET_NOMENCLATURES_SUCCESS]: mutationGetNomenclaturesSuccess,
  [GET_NOMENCLATURES_ERROR]: mutationsGetNomenclaturesError,
}
